module.exports = "/_next/static/images/8e950748ae86bed8de641cb8a575d51a-sparkles.svg.webp";